<template>
  <div
    class="shows-page"
    data-test="page-shows">
    <section
      class="hero"
      data-test="section-hero">
      <div class="banner">
        <div class="banner-background">
          <div class="container">
            <div class="art-container">
              <span class="text-tag">FEATURED SHOW</span>
              <span class="text-label">Coming Sept. 2019</span>
              <img
                :src="srcSet('src', banner_art)"
                :srcset="srcSet('srcset', banner_art)"
                class="art-image">
            </div>
          </div>
        </div>
        <div class="banner-content container">
          <h1 class="banner-title">Shows for every <span class="next-line">day of the week</span></h1>
          <p class="banner-desc">Sign up for Luminary Premium and listen to new podcasts from creators you love and more launching monthly.</p>
          <el-button
            data-test="btn-premium"
            class="el-button el-button--primary banner-btn"
            @click="goTo('/signup')"
          >Try
            <span
              v-if="promoMeta.trialPeriod > 1"
              class="line-through">1 month</span> {{ promoMeta.formattedTrialPeriod }} of Premium free</el-button>
          <p class="fine-print">{{ defaultPrice.price | amountFilter(defaultPrice.currency) }} after <br>
            <span class="fine-print dark">Cancel anytime.
              <router-link
                data-test="link-terms"
                class="dark"
                target="_blank"
                to="/termsfreetrial"
              >
                Terms apply.
              </router-link>
            </span>
          </p>
          <div class="art-container">
            <span class="text-tag">FEATURED SHOW</span>
            <span class="text-label">Coming Sept. 2019</span>
            <img
              :src="srcSet('src', banner_art)"
              :srcset="srcSet('srcset', banner_art)"
              class="art-image">
          </div>
        </div>
      </div>
    </section>
    <section
      class="premium-shows-section"
      data-test="section-premiumshows">
      <div class="premium-shows container">
        <h4 class="section-title">LUMINARY ORIGINALS</h4>
        <h1 class="subtitle">Explore the collection of Premium Podcasts</h1>
        <loader
          v-show="!exclusive_podcasts_loaded"
          :with-margin="true"
          label="Fetching Luminary Exclusives..." />
        <podcast-list
          v-if="exclusive_podcasts_loaded"
          :bucket="exclusive_podcasts"
          :is-stacked="true"
          type="podcast"/>
      </div>
    </section>
    <section
      v-if="showComingSoon"
      class="soon">
      <div class="coming-soon">
        <div class="container">
          <h4 class="section-title">COMING SOON TO LUMINARY</h4>
          <div class="show-tile-grid">
            <div
              v-for="(show, index) in coming_soon"
              :key="`show-${index}`"
              class="show-tile">
              <h4 class="show-title">{{ show.title }}</h4>
              <p class="show-description">{{ show.desc }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="how-to">
      <app-download />
    </section>
    <section class="pricing-cards">
      <div class="container">
        <h4 class="section-title">LISTEN NOW</h4>
        <price-cards
          :adjust-to-sm="true"/>
      </div>
    </section>
    <custom-info
      :show="showInfoModal"
      :header="infoHeader"
      :description="infoDescription"
      @closeInfoModal="closeInfoModal"
    />
  </div>
</template>

<script>
import * as log from 'loglevel';
import PriceCards from '../components/PriceCards';
import Loader from '../components/Loader';
import PodcastService from '../services/Podcast';
import PodcastList from '../components/PodcastList';
import ArtGrid from '../components/ArtGrid';
import AppStoreLinks from '../components/AppStoreLinks';
import AppDownload from '../components/AppDownload';
import hollywood1x from '../assets/images/home/hollywood_1x.png';
import hollywood2x from '../assets/images/home/hollywood_2x.png';
import hollywood3x from '../assets/images/home/hollywood_3x.png';
import twoPhones1x from '../assets/images/threePhones_1x.png';
import twoPhones2x from '../assets/images/threePhones_2x.png';
import twoPhones3x from '../assets/images/threePhones_3x.png';
import PageMixin from '../shared/pageMixin';
import CustomInfoModal from '../components/InfoCustomModal';


export default {
  name: 'PremiumShows',
  components: {
    'podcast-list': PodcastList,
    'price-cards': PriceCards,
    'art-grid': ArtGrid,
    'appstore-links': AppStoreLinks,
    'app-download': AppDownload,
    'custom-info': CustomInfoModal,
    Loader,
  },
  mixins: [PageMixin],
  data() {
    return {
      pageName: 'Premium Shows',
      premium_content: [
        { title: 'A new podcast app', description: 'Listen to all your regular podcasts and utilize advanced search and personalize recommendations. All for free.' },
        { title: 'Luminary Premium', description: '40+ shows from top creators you’ll only hear with Luminary Premium.' },
        { title: 'Customized for you', description: 'Customized recommendations tailored to your taste' },
      ],
      showComingSoon: false,
      coming_soon: [
        {
          title: 'Celeste & Her Best',
          desc: 'Actor, writer, comedian, and queen of Instagram, Celeste Barber is going to podtown.',
        },
        {
          title: 'Jigsaw Productions',
          desc: 'An audio documentary from Academy Award-winning filmmaker Alex Gibney (The Armstrong Lie, The Inventor: Out For Blood In Silicon Valley) and Jigsaw Productions',
        },
        {
          title: 'Team Coco',
          desc: 'Scripted podcasts from the world’s most trusted comedy brand in the universe',
        },
        {
          title: 'Karamo',
          desc: 'A super-intimate (brand new) podcast from Karamo of Queer Eye.',
        },
        {
          title: "Lena Dunham's The C-Word",
          desc: 'A new podcast about women history loves to call "crazy."',
        },
        {
          title: "Players' Tribune: The Podcast",
          desc: 'A weekly collection of compelling stories that reach beyond the obvious topics to expose the soul of sports.',
        },
      ],
      banner_art: [hollywood1x, hollywood2x, hollywood3x],
      podcast_service: new PodcastService(),
      exclusive_podcasts: { items: [] },
      exclusive_podcasts_loaded: false,
      twoPhonesImgs: [twoPhones1x, twoPhones2x, twoPhones3x],
      showInfoModal: false,
      infoHeader: '',
      infoDescription: '',
    };
  },
  computed: {
    defaultPrice() {
      return this.$store.getters.pricing;
    },
  },
  beforeMount() {
    this.getLuminaryExclusiveShows();
  },
  methods: {
    getLuminaryExclusiveShows() {
      this.podcast_service.getExclusivePodcasts().then((res) => {
        this.exclusive_podcasts.items = res.podcasts || [];
        this.exclusive_podcasts.items = res.podcasts.map(item => ({ ...item, publisher_name: item.description }));
        this.exclusive_podcasts_loaded = true;
      }).catch(error => log.info(error.message));
    },
    goTo(path) {
      const { user } = this.$store.getters;
      if (user && user.is_subscribed) {
        this.displayInfoModal();
      } else {
        this.$router.push(path);
      }
    },
    displayInfoModal() {
      this.infoHeader = 'Info';
      this.infoDescription = 'You are already a Premium subscriber';
      this.showInfoModal = true;
    },
    closeInfoModal() {
      this.showInfoModal = false;
    },
  },
};
</script>

<style lang="scss">
@import '../assets/scss/mixins.scss';
.shows-page {
  .premium-shows-section {
    .premium-shows {
      .container {
        @media (max-width: 576px) {
          margin: 0px;
          width: 100%;
        }
        .podcast-list {
          .flickity-enabled {
            .flickity-button {
              background-color: #ffffff00 !important;
              box-shadow: none;
              top: 46% !important;
              &.next {
                right: -54px !important;
              }
              &.previous {
                left: -54px !important;
              }
            }
          }
          .podcast-card {
            @media (max-width: 576px) {
              height: 250px;
              margin-bottom: 0px;
            }
            .podcast-content {
              text-align: left;
              padding-top: 14px;
              .podcast-title {
                text-align: left;
                font-size: 18px;
                line-height: 24px;
                display: inline;
                white-space: unset;
                text-overflow: unset;
                @media (max-width: 576px) {
                  font-size: 14px;
                  line-height: 18px;
                }
              }
              .publisher-name {
                text-align: left;
                margin-top: 8px !important;
                font-size: 15px;
                color: #474747;
                text-transform: none;
                @include multilinetruncate(15px, 19px, 2);
                @media (max-width: 576px) {
                  margin-top: 4px;
                  font-size: 12px;
                  line-height: 16px;
                  @include multilinetruncate(12px, 16px, 2);
                }
              }
            }
            &:hover {
              .podcast-content {
                .podcast-title {
                  border-bottom: 2px solid #00BEDE;
                }
              }
            }
          }
        }
      }
    }
  }
}
@media (max-width: 768px) {
.shows-page {
  .premium-shows-section {
    .premium-shows {
      .container {
        .podcast-list {
          .flickity-enabled {
            .flickity-button {
              background-color: #ffffff00 !important;
              box-shadow: none;
              top: 46% !important;
              &.next {
                right: -36px !important;
              }
              &.previous {
                left: -36px !important;
              }
            }
          }
        }
      }
    }
  }
}
}
</style>

<style lang="scss" scoped>
@import "../assets/scss/variables.scss";

.shows-page {
  .banner {
    width: 100%;
    max-height: 550px;
    background-color: #111111;
    display: flex;
    overflow: hidden;
    position: relative;
    .banner-background {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      /* .art-container {
        float: right;
        width: 641px;
        height: 384px;
        overflow: hidden;
        margin-top: 80px;
        margin-right: -68px;
        .art-image {
          width: 100%;
          margin-top: -31%;
        }
      } */
      .art-container {
        float: right;
        width: 641px;
        /* height: 100%; */
        height: 384px;
        overflow: hidden;
        margin-top: 80px;
        margin-right: -68px;
        position: relative;
        .text-tag {
          position: absolute;
          color: white;
          left: 0;
          top: 0;
          padding: 18px 0 0 18px;
          font-size: 20px;
          font-weight: bold;
          letter-spacing: 1.5px;
        }
        .text-label {
          display: none;
          position: absolute;
          color: black;
          left: 0;
          bottom: 0;
          padding: 0 0 14px 16px;
          font-size: 16px;
          font-weight: bold;
          background-color: white;
          border-radius: 1px;
          padding: 11px 17px;
          margin: 0 0 18px 16px;
        }
        .art-image {
          display: block;
          width: 100%;
          margin-top: -32%;
          margin-bottom: -12%;
        }
      }
    }
    .banner-content {
      padding: 61px 50px 50px 50px;
      z-index: 1;
      .art-image {
        display: none;
      }
      .banner-title {
        font-size: 76px;
        margin: 0 0 30px 0;
        max-width: 640px;
        font-family: $clearface-bold;
        color: #fff;
        line-height: 79px;
        letter-spacing: -1.9px;
        .next-line {
          display: block;
        }
      }
      .banner-desc {
        color: #fff;
        font-size: 20px;
        line-height: 28px;
        max-width: 491px;
        margin: 0 0;
        margin-bottom: 50px;
        font-family: Favorit-light;
        a {
          color: #fff;
          text-decoration: underline;
        }
      }
      .banner-btn {
        padding: 16px 23px;
        font-size: 17px;
        color: $black;
        background: $brand;
        border: none;
        text-decoration: underline;
        text-transform: none;
        margin-bottom: 22px;
        box-shadow: 6px 5px 0px rgba(255,229,0,0.3);
        &:hover {
          background-color: #C7B302 !important;
        }
      }
      .fine-print {
        color: $white;
        font-family: Favorit-light;
        font-size: 16px;
        letter-spacing: -0.21px;
        line-height: 22px;
        margin: 0px;
        & a.dark {
          color: #9B9B9B;
        }
      }

      .fine-print > a {
        text-decoration: underline;
      }
    }
    .bg-image {
      max-width: 45%;
      max-height: 580px;
    }
  }
  .coming-soon {
    background: linear-gradient(90deg, $brand 50%, $white1 50%);
    /* height: 500px; */
    text-align: center;
    .section-title {
      margin-top: 0px;
      font-size: 18px;
      letter-spacing: 1px;
      color: $black1;
      padding-top: 52px;
      padding-bottom: 49px;
    }
    .show-tile-grid {
      display: flex;
      flex-wrap: wrap;
      .show-tile {
        width: 50%;
        align-self: center;
        flex: 0 0 auto;
        margin-bottom: 40px;
        min-height: 140px;
        .show-title {
          color: #2B303A;
          font-family: $clearface-bold;
          font-size: 38px;
          letter-spacing: -0.95px;
          line-height: 45px;
          text-align: center;
          margin: 0 0 16px;
        }
        .show-description {
          color: #474747;
          font-family: Favorit-light;
          font-size: 18px;
          letter-spacing: -0.23px;
          line-height: 28px;
          text-align: center;
          padding: 0 16%;
        }
      }
    }
  }
  .pricing-cards {
    padding: 70px 0 76px 0;
    background-color: #F5F4F4;
  }
  .premium-shows {
    text-align: center;
    padding: 61px 0px 0px 0px;
    margin-bottom: 60px;
    .section-title {
      margin-top: 0px;
      margin-bottom: 0;
      font-size: 18px;
      letter-spacing: 1px;
      font-weight: 600;
      color: #2B303A;
    }
    .podcast-list {
      .podcast-card {
        height: 287px;
        width: 287px;
        .podcast-image {
          height: 287px;
        }
        .podcast-content {
          .podcast-title {
            font-size: 18px;
            line-height: 24px;
            height: 33px;
            overflow: hidden;
            text-overflow: ellipsis;
            text-align: left !important;
          }
          .publisher-name {
            font-size: 16px;
            line-height: 22px;
            overflow: hidden;
            height: 45px;
            text-overflow: ellipsis;
            margin-top: 5px !important;
            text-align: left !important;
            text-transform: none;
          }
        }
      }
      .flickity-viewport {
       padding-bottom: 140px;
      }
      .flickity-button {
        box-shadow: 0 0 !important;
        top: 35% !important;
        &:nth-of-type(1) {
          left: -50px !important;
        }
        &:nth-of-type(2) {
          right: -50px !important;
        }
      }
    }
    .subtitle {
      margin: 16px 0 49px 0;
      letter-spacing: -2.01px;
      line-height: 48px;
      font-size: 48px;
      font-family: $clearface-bold;
    }
    .desc {
      font-size: 20px;
      line-height: 24px;
      color: #474747;
      margin: 22px 0 40px 0;
      font-family: Favorit-light;
      letter-spacing: -0.42px;
    }
  }
  .hot-to {
    margin: 20px 0;
  }
  .pricing-cards {
    .section-title {
      margin: 0 0 39px;
      text-align: center;
      font-size: 18px;
      letter-spacing: 1px;
    }
  }
}

@media (max-width: 1328px) {
  .shows-page {
    .banner {
      .banner-background {
        .art-container {
          margin-top: 55px;
          margin-right: -3px;
        }
      }
      .banner-content {
        padding-left: 0px;
        .banner-title {
          font-size: 50px;
          line-height: 50px;
          max-width: 440px;
        }
        .banner-desc {
          max-width: 45%;
        }
      }
    }
  }
}

@media (max-width: 1240px) {
  .shows-page {
    .banner {
      .banner-background {
        .art-container {
          margin-right: -109px;
        }
      }
    }
  }
}

@media (max-width: 1024px) {
  .shows-page {
    .banner {
      .banner-content {
        padding: 33px 0px 28px 7vw;
        margin: 10px 409px 0 0px;
        .banner-title {
          font-size: 42px;
          line-height: 41px;
          letter-spacing: -1px;
          margin-bottom: 20px;
          .next-line {
            display: block;
          }
        }
        .banner-desc {
          font-size: 15px;
          line-height: 20px;
          margin-bottom: 28px;
          max-width: 68%;
        }
        .banner-btn {
          margin-bottom: 12px;
        }
        .fine-print {
          color: white;
          font-size: 14px;
          font-family: Favorit-light;
          &.dark {
            font-size: 12px;
            font-family: Favorit-light;
            color: #666666;
          }
        }
      }
      .banner-background {
        .art-container {
          margin-top: 45px;
          width: 50%;
          max-height: 280px;
          margin-right: -60px;
          min-width: 450px;
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .shows-page {
    .banner {
      max-height: none;
      .banner-background {
        display: none !important;
      }
      .banner-content {
        /* margin: 28% 20px 0px; */
        margin: 0;
        padding: 33px 0 28px;
        width: 100%;
        text-align: center;
        .art-container {
          width: 95%;
          margin: 40px 2.5% 30px;
          overflow: hidden;
          position: relative;
          .text-tag {
            position: absolute;
            color: white;
            left: 0;
            top: 0;
            padding: 14px 0 0 16px;
            font-size: 16px;
            font-weight: bold;
            letter-spacing: 1.5px;
          }
          .text-label {
            display: none;
            position: absolute;
            color: black;
            left: 0;
            bottom: 0;
            padding: 0 0 14px 16px;
            font-size: 16px;
            font-weight: bold;
            background-color: white;
            border-radius: 1px;
            padding: 11px 15px;
            margin: 0 0 14px 16px;
          }
          .art-image {
            display: block;
            width: 100%;
            margin-top: -32%;
            margin-bottom: -12%;
          }
        }
        .fine-print {
          font-size: 14px;
          margin-top: 20px;
          &.dark {
            font-size: 14px;
          }
        }
        .banner-title {
          max-width: none;
          font-size: 50px;
          line-height: 52px;
        }
        .banner-desc {
          font-size: 16px;
          line-height: 22px;
          padding: 0 13%;
          max-width: 100% !important;
        }
        .banner-btn {
          margin: 0 auto;
        }
      }
      .bg-image {
        display: none;
      }
    }
    .coming-soon {
      .show-tile-grid {
        .show-tile {
          width: 100%;
        }
      }
    }
  }
}

@media (max-width: 576px) {
  .shows-page {
    .premium-shows {
      padding: 28px 0px !important;
      margin-bottom: 0;
      .section-title {
        font-size: 14px;
      }
      .subtitle {
        font-size: 36px;
      }
      .desc {
        font-size: 18px;
      }
      .podcast-list {
        .podcast-card {
          height: 140px;
          width: 140px;
          .podcast-image {
            height: 140px;
          }
          .podcast-content {
            .podcast-title {
              font-size: 14px;
              line-height: 22px;
              height: 23px;
              overflow: hidden;
              text-overflow: ellipsis;
              margin-top: 6px;
            }
            .publisher-name {
              font-size: 12px;
              line-height: 16px;
              height: 33px;
              overflow: hidden;
              text-overflow: ellipsis;
              margin-top: 4px;
              text-transform: none;
            }
          }
        }
        .flickity-button {
          box-shadow: 0 0 !important;
          top: 35% !important;
          &:nth-of-type(1) {
            left: -50px !important;
          }
          &:nth-of-type(2) {
            right: -50px !important;
          }
        }
      }
    }
    .pricing-cards {
      .container {
        .section-title {
          font-size: 14px;
          margin-bottom: 16px;
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// app/src/pages/PremiumShows.vue